import TvContent from './Content'
import PrevueList from './PrevueList'
import VipHeader from './VipHeader'
import VipInnerHeader from './VipInnerHeader'
let isInner = window.location.href.indexOf('inner') > -1
const components = {
  TvContent,
  PrevueList,
  VipHeader: isInner ? VipInnerHeader : VipHeader
}

export default function install (Vue) {
  Object.keys(components).forEach(key => {
    Vue.component(key, components[key])
  })
}



// WEBPACK FOOTER //
// ./src/views/tv/modules/index.js